import styled, { css, keyframes } from 'styled-components';

const ANIMATION_SPEED = 1.25;
const ANIMATION_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

const squareKeyframes = keyframes`
  0% { transform: rotate(0) }
  50%, 100% { transform: rotate(90deg) }
`;

const partKeyframes = keyframes`
  0%, 50% { visibility: hidden }
  100% { visibility: visible }
`;

const partAnimation = css`
  animation: ${partKeyframes} ${ANIMATION_SPEED}s linear infinite;
`;

const partAnimationDelayed = css`
  animation: ${partKeyframes} ${ANIMATION_SPEED}s ${ANIMATION_SPEED / 2}s linear infinite;
`;

const bottomLeftSquareTransformOrigin = css`
  transform-origin: 15.125px 24.875px;
`;

const topRightSquareTransformOrigin = css`
  transform-origin: 24.875px 15.125px;
`;

export const BottomLeftSquare = styled.path`
  animation: ${squareKeyframes} ${ANIMATION_SPEED}s ${ANIMATION_SPEED / 2}s ${ANIMATION_EASING}
    infinite;
  ${bottomLeftSquareTransformOrigin}
`;

export const BottomLeftSquareBorderMask = styled.path`
  animation:
    ${squareKeyframes} ${ANIMATION_SPEED}s ${ANIMATION_SPEED / 2}s ${ANIMATION_EASING} infinite,
    ${partKeyframes} ${ANIMATION_SPEED}s linear infinite;
  ${bottomLeftSquareTransformOrigin}
  fill: black !important;
`;

export const TopRightSquare = styled.path`
  animation: ${squareKeyframes} ${ANIMATION_SPEED}s ${ANIMATION_EASING} infinite;
  ${topRightSquareTransformOrigin}
`;

export const TopRightSquareBorderMask = styled.path`
  animation:
    ${squareKeyframes} ${ANIMATION_SPEED}s ${ANIMATION_EASING} infinite,
    ${partKeyframes} ${ANIMATION_SPEED}s ${ANIMATION_SPEED / 2}s linear infinite;
  ${topRightSquareTransformOrigin}
  fill: black !important;
`;

export const TopPart = styled.rect`
  ${partAnimation}
`;

export const TopPartBorder = styled.path`
  ${partAnimation}
  fill: black !important;
`;

export const RightPart = styled.rect`
  ${partAnimationDelayed}
`;

export const RightPartBorder = styled.path`
  ${partAnimationDelayed}
  fill: black !important;
`;

export const WhiteRect = styled.rect`
  fill: white !important;
`;

const singleSquareKeyframes = keyframes`
  0% { transform: rotate(0) }
  100% { transform: rotate(90deg) }
`;

export const SingleSquare = styled.path`
  animation: ${singleSquareKeyframes} ${ANIMATION_SPEED / 2}s ${ANIMATION_EASING} infinite;
  ${topRightSquareTransformOrigin};
  transform-origin: 50%;
`;
